import React from 'react';
import '../styles/MobileBackground.css';

/**
 * Lightweight static gradient background for mobile/tablet devices
 * Replaces the canvas-based animated Background component for better performance
 */
function MobileBackground() {
  return (
    <div className="mobile-background">
      <div className="mobile-bg-gradient gradient-1"></div>
      <div className="mobile-bg-gradient gradient-2"></div>
      <div className="mobile-bg-gradient gradient-3"></div>
    </div>
  );
}

export default MobileBackground;
